/**
 * 시간 포맷팅 유틸리티 함수
 * 모든 함수는 사용자의 브라우저 timezone에 맞게 시간을 표시합니다.
 */

/**
 * datetime-local input 값을 UTC ISO 문자열로 변환
 * datetime-local은 timezone 정보 없이 로컬 시간을 반환하므로,
 * 브라우저의 로컬 timezone을 기준으로 UTC로 변환합니다.
 * 예: "2026-01-22T18:30" (EST) → "2026-01-22T23:30:00.000Z" (UTC)
 */
export function localToUtcIso(datetimeLocalValue: string): string {
  if (!datetimeLocalValue) return "";
  const date = new Date(datetimeLocalValue);
  return date.toISOString();
}

/**
 * UTC ISO 문자열을 datetime-local input 형식으로 변환
 * 사용자의 로컬 timezone에 맞게 변환합니다.
 * 예: "2026-01-22T23:30:00.000Z" (UTC) → "2026-01-22T18:30" (EST)
 */
export function utcIsoToLocal(isoString: string): string {
  if (!isoString) return "";
  const date = new Date(isoString);
  // datetime-local 형식: YYYY-MM-DDTHH:mm
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

/**
 * ISO 문자열을 "월 일 시:분" 형식으로 포맷팅
 * 예: "1월 20일 오후 7:00"
 */
export function formatDateTime(isoString?: string): string {
  if (!isoString) return "";
  const date = new Date(isoString);
  return date.toLocaleString("ko-KR", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * ISO 문자열을 "시:분" 형식으로 포맷팅 (시간만)
 * 예: "오후 7:00"
 */
export function formatTimeOnly(isoString?: string): string {
  if (!isoString) return "";
  const date = new Date(isoString);
  return date.toLocaleTimeString("ko-KR", {
    hour: "2-digit",
    minute: "2-digit",
  });
}
